<div class="input-group me-2">
  <label class="input-group-text">Fitness metric</label>
  <select (change)="selectedFitnessMetric.emit(getValue($event, false))" class="form-select"
          name="status">
    <option *ngFor="let metric of list" [selected]="metric.selected"
            [value]="metric.value">{{metric.label}}</option>
  </select>
</div>
